import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { NameSchema } from '../../Generic/models/Name'
import { UrlSchema } from '../../Generic/models/Url'
import { IdSchema } from '../../Generic/models/Id'
import { GameSocialChannelSchema } from './GameSocialChannel'
import { ProductSchema } from './Product'
import { TokenSchema } from './Token'
import { InvestorSchema } from './Investor'

export const GameSchema = z.object({
  id: IdSchema,
  name: NameSchema,
  description: z.string().optional(),
  image: UrlSchema,
  website: UrlSchema,
  roadmap: UrlSchema.optional(),
  roadmapAvailableAt: z.date().nullable(),
  docs: z.array(UrlSchema),
  calculators: z.array(UrlSchema),
  channels: z.array(GameSocialChannelSchema),
  investors: z.array(InvestorSchema),
  investorsCount: z.number(),
  products: z.array(ProductSchema),
  tokens: z.array(TokenSchema),
})

export const GamesSchema = z.array(GameSchema)
  .superRefine(getDuplicatesRefinement('Game', parseGameUid))

export const GameUidSchema = GameSchema.pick({
  id: true,
})

export type Game = z.infer<typeof GameSchema>

export type GameUid = z.infer<typeof GameUidSchema>

export function parseGame(game: Game): Game {
  return GameSchema.parse(game)
}

export function parseGames(games: Game[]): Game[] {
  return GamesSchema.parse(games)
}

export function parseGameUid(gameUid: GameUid): GameUid {
  return GameUidSchema.parse(gameUid)
}
